// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FieldURIOrConstantType from "../contract/FieldURIOrConstantType";

export default function fieldURIOrConstantType(data: FieldURIOrConstantType): FieldURIOrConstantType {
    const result: FieldURIOrConstantType = {
        __type: "FieldURIOrConstantType:#Exchange",
        ...data,
    };
    
    return result;
}
